function getConfigValue(projectName, key) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!window._cianConfig) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const config = window._cianConfig[projectName];
        if (!config) {
            return;
        }
        return searchInConfig(config, key);
    }
    catch (error) {
        console.error(error);
        return;
    }
}
function searchInConfig(config, target) {
    return config.find(({ key }) => key === target)?.value;
}

export { getConfigValue };
//# sourceMappingURL=getConfigValue.mjs.map
